const CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function generateCaptchaText(length = 5) {
  let text = '';
  for (let i = 0; i < length; i += 1) {
    text += CHARSET[Math.floor(Math.random() * CHARSET.length)];
  }
  return text;
}

export function verifyCaptcha(answer, expected) {
  return answer.trim().toUpperCase() === expected.toUpperCase();
}
